import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { getQuizResultsByModuleId } from '../services/quizApi';
import AdminNav from '../components/AdminNav';

const AdminQuizResultsPage = () => {
  const [moduleId, setModuleId] = useState('');
  const [submittedModuleId, setSubmittedModuleId] = useState('');

  const { data: quizResults, isLoading, error, isFetching } = useQuery(
    ['quizResults', submittedModuleId],
    () => getQuizResultsByModuleId(submittedModuleId),
    {
      enabled: !!submittedModuleId, // Only run the query if submittedModuleId is not empty
    }
  );

  const handleFetchResults = (e) => {
    e.preventDefault();
    if (!moduleId) {
      return;
    }
    setSubmittedModuleId(moduleId);
  };

  return (
    <div style={{ padding: '20px' }}>
      <AdminNav />
      <h1>Admin - Quiz Results</h1>
      <form onSubmit={handleFetchResults} style={{ marginBottom: '20px' }}>
        <input
          type="text"
          value={moduleId}
          onChange={(e) => setModuleId(e.target.value)}
          placeholder="Enter Module ID"
          style={{ padding: '8px', marginRight: '10px' }}
        />
        <button type="submit" style={{ padding: '8px' }} disabled={isLoading || isFetching}>
          {isLoading || isFetching ? 'Fetching...' : 'Get Results'}
        </button>
      </form>

      {error && <div style={{ color: 'red', marginBottom: '20px' }}>Error: {error.message}</div>}

      {quizResults && quizResults.length > 0 && (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={tableHeaderStyle}>Result ID</th>
              <th style={tableHeaderStyle}>User ID</th>
              <th style={tableHeaderStyle}>Module ID</th>
              <th style={tableHeaderStyle}>Result</th>
              <th style={tableHeaderStyle}>Total Marks</th>
              <th style={tableHeaderStyle}>Percentage</th>
              <th style={tableHeaderStyle}>Points</th>
              <th style={tableHeaderStyle}>Taken At</th>
            </tr>
          </thead>
          <tbody>
            {quizResults.map((result) => (
              <tr key={result.resultId}>
                <td style={tableCellStyle}>{result.resultId}</td>
                <td style={tableCellStyle}>{result.userId}</td>
                <td style={tableCellStyle}>{result.moduleId}</td>
                <td style={tableCellStyle}>{result.result}</td>
                <td style={tableCellStyle}>{result.totalMarks}</td>
                <td style={tableCellStyle}>{result.percentage.toFixed(2)}%</td>
                <td style={tableCellStyle}>{result.points}</td>
                <td style={tableCellStyle}>{new Date(result.takenAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

const tableHeaderStyle = {
  border: '1px solid #ddd',
  padding: '8px',
  textAlign: 'left',
  backgroundColor: '#f2f2f2',
};

const tableCellStyle = {
  border: '1px solid #ddd',
  padding: '8px',
};

export default AdminQuizResultsPage;
